module.exports = __webpack_public_path__ + "img/MH.172c13d4.png";